// Cross-app CUI spotlight tour flow IDs and priority tiers (mf-publisher host + oap-web remotes).
// oap-web mirrors these values in app/src/constants/spotlightTours.ts — keep in sync.

/** Higher number wins when multiple tours register in the same SpotlightProvider. */
export const SPOTLIGHT_TOUR_PRIORITY = {
  // User-initiated from the nav entry card, so it should win over auto-shown tours when invoked.
  BRAND_REFRESH_NAV: 110,
  MEETINGS_ONBOARDING: 100,
  CRM_CONTACTS_NOTES_TABLE: 80,
  CRM_CONTACTS_COLUMNS: 70,
  CRM_ADD_CONTACT: 60,
  CRM_CONTACTS_LISTS: 50,
  CRM_CONTACTS_NOTES_TAB: 45,
  CRM_CONTACTS_EMAILS_TAB: 44,
  CRM_CONTACTS_FILTER: 30,
  AI_CHAT_DISCOVERY: 10,
}

export const SPOTLIGHT_TOUR_FLOW_ID = {
  BRAND_REFRESH_NAV: 'brand_refresh_nav_tour',
  MEETINGS_ONBOARDING: 'meetings_page_onboarding_tour',
  CRM_ADD_CONTACT: 'crm-add-contact-tour',
  AI_CHAT_DISCOVERY_TOP: 'ai_chat_discovery_top_right_spotlight',
  AI_CHAT_DISCOVERY_FAB: 'ai_chat_discovery_fab_spotlight',
  CRM_CONTACTS_COLUMNS: 'contacts-columns-spotlight',
  CRM_CONTACTS_LISTS: 'contacts-lists-spotlight',
  CRM_CONTACTS_FILTER: 'contacts-filter-spotlight',
  CRM_CONTACTS_NOTES_TABLE: 'contacts-notes-table-spotlight',
  CRM_CONTACTS_NOTES_TAB: 'contacts-notes-tab-spotlight',
  CRM_CONTACTS_EMAILS_TAB: 'contacts-emails-tab-ai-spotlight',
}
